import { 
    gql, 
    useMutation 
} from "@apollo/client";
import { 
    CreateWithdrawalAdminMutationMutation,
    CreateWithdrawalAdminMutationMutationVariables 
} from "../../../../../schemaTypes";
import { normalizeErrors } from "../../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../../types/NormalizedErrorMap";
import { ReactElement } from "react";

export const createWithdrawalAdminMutation = gql`
  mutation CreateWithdrawalAdminMutation(
        $input: CreateWithdrawalInputAdmin!
    ) {
        createWithdrawalAdmin(
            input: $input
            ) {
            errors {
                path
                message
            }
            message
        }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateWithdrawalAdmin: (
        values: CreateWithdrawalAdminMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createWithdrawalAdminData: any | null; 
    }
  ) => ReactElement | null;
}

export const CreateWithdrawalAdminController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateWithdrawalAdminMutationMutation,
    CreateWithdrawalAdminMutationMutationVariables
  >(
    createWithdrawalAdminMutation
  );

  const submitCreateWithdrawalAdmin = async (values: CreateWithdrawalAdminMutationMutationVariables) => {
    const { data: {createWithdrawalAdmin} }:any = await mutate({ variables: values });

    if (createWithdrawalAdmin?.errors) {
      return {error: normalizeErrors(createWithdrawalAdmin.errors), createWithdrawalAdmin: null};
    }

    return {
      error: null,
      createWithdrawalAdmin
    };
  };

  const message = data?.createWithdrawalAdmin.message || null;

  return children({
    submitCreateWithdrawalAdmin,
    loading,
    error,
    message,
    createWithdrawalAdminData: data,
  });
};